import * as React from 'react';

import PreviewLakeLogsButton from './PreviewLakeLogsButton';

type Props = Omit<React.ComponentProps<typeof PreviewLakeLogsButton>, 'urlParams'> & {
  tableId?: string;
  dataLakeId: string;
};

const PreviewExternalLakeLogsButton = ({
  bsStyle,
  bsSize,
  target,
  children,
  tableId = undefined,
  dataLakeId,
  onClick,
}: Props) => (
  <PreviewLakeLogsButton
    bsStyle={bsStyle}
    bsSize={bsSize}
    target={target}
    dataLakeId={dataLakeId}
    onClick={onClick}
    urlParams={tableId ? `streams=${tableId}` : undefined}>
    {children}
  </PreviewLakeLogsButton>
);

export default PreviewExternalLakeLogsButton;
